import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Daily.css'; // Reutilizamos estilos
import slide1 from '../assets/Daily1.avif';
import slide2 from '../assets/Daily2.avif';
import slide3 from '../assets/daily3.avif';
import slide4 from '../assets/Daily4.avif';
import slide5 from '../assets/Daily5.avif';
import slide6 from '../assets/Daily6.avif';
import slide7 from '../assets/Farmatodo2.avif';
import { Package, DollarSign, Users, Archive, ChartColumn, Activity, Handshake, Landmark } from 'lucide-react';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const Daily = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="dashboard-container"
      initial={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      animate={isMobile ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 }}
      exit={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={isMobile ? { duration: 0 } : { duration: 0.5 }}
    >
      <div className="title-section">
        <h1 className="dailymenu">Gestión de Ventas</h1>
        <div className="title-underline-daily"></div>
        <h1 className="subtitle-daily">Daily Report <span onClick={() => navigate('/dprincipal')}><div className="daily-card-icon-wrapper2">
                <ChartColumn size={28} color="white" />
              </div></span></h1>
      </div>

      <div className="daily-menu-grid">
          {/* Card 1: Ventas Bultos */}
          <div className="daily-card" onClick={() => navigate('/bultos')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide1})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Package size={28} color="white" />
              </div>
              <h3>Ventas Bultos</h3>
              <p>Análisis de volumen y cumplimiento de cuotas.</p>
            </div>
          </div>

          {/* Card 2: Ventas USD */}
          <div className="daily-card" onClick={() => navigate('/usdsales')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide2})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <DollarSign size={28} color="white" />
              </div>
              <h3>Ventas USD</h3>
              <p>Analisis de ventas y cumplimiento de ingresos netos en USD.</p>
            </div>
          </div>

          {/* Card 3: Regiones */}
          <div className="daily-card" onClick={() => navigate('/asesores')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide3})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Users size={28} color="white" />
              </div>
              <h3>Asesores</h3>
              <p>Desempeño de Asesores de Ventas / Clientes.</p>
            </div>
          </div>

          {/* Card 4: Inventario */}
          <div className="daily-card" onClick={() => navigate('/inventario')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide4})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Archive size={28} color="white" />
              </div>
              <h3>Inventario</h3>
              <p>Consulta de stock y disponibilidad de productos.</p>
            </div>
          </div>

          {/* Card 5: Activación */}
          <div className="daily-card" onClick={() => navigate('/activacion')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide5})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Activity size={28} color="white" />
              </div>
              <h3>Activación</h3>
              <p>Consulta de activación de clientes.</p>
            </div>
          </div>

          {/* Card 6: Sugeridos */}
          <div className="daily-card" onClick={() => navigate('/sugeridos')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide6})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Handshake size={28} color="white" />
              </div>
              <h3>Sugeridos</h3>
              <p>Consulta de productos sugeridos.</p>
            </div>
          </div>
           {/* Card 7:uFarmatodo */}
          <div className="daily-card" onClick={() => navigate('/farmatodo')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide7})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Landmark size={28} color="white" />
              </div>
              <h3>Farmatodo</h3>
              <p>Analisis de Desempeño Canal Farmatodo.</p>
            </div>
          </div>
      </div>
    </motion.div>
  );
};

export default Daily;